export default __webpack_public_path__ + "static/media/icon-success.dcbf1f80.svg";